<template>
  <div class="container">
    <skeleton v-if="loading" />
    <timeout v-else-if="isShowTimeout" />
    <offline v-else-if="isShowOffline" />
    <home :data="apolloData" v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "@vue/composition-api";
import skeleton from "./skeleton.vue";
import home from "./home.vue";
import offline from "./offline.vue";
import timeout from "./timeout.vue";
import { queryApolloConfig } from "@/api/market";
import log from "@/utils/log";
import { querySet } from "@/utils/url";
import { TMarketApolloData,TResourceItem } from "./type";
import Omega from "@/utils/register/omega";
import { getOmegaApplySource } from "@/utils/common";
import { setPageId } from '@/utils/register/omega'
import { PAGE_ID } from '@/constants/page-id'

export default defineComponent({
  name: "market-index",
  components: {
    skeleton,
    home,
    offline,
    timeout,
  },
  setup() {
    const { resource, materialType } = querySet;
    const loading = ref(false);
    const isShowOffline = ref(false);
    const isShowTimeout = ref(false);
    const apolloData = ref<TResourceItem | null>(null)
    function getApolloConfigMap(data: TMarketApolloData | null) {
      if (materialType) {
        // 不同素材不同链接
        const pagesDifferent = data?.pagesDifferent
        const pagesDifferentArr = Array.isArray(pagesDifferent) ? pagesDifferent : []
        return pagesDifferentArr.find((item) => item?.resource === resource && item?.materialType === materialType)
      } else {
        // 默认素材链接
        const pages = data?.pages
        const pagesArr = Array.isArray(pages) ? pages : []
        return pagesArr.find((item) => item?.resource === resource)
      }
    }

    async function getApolloConfig() {
      loading.value = true;
      setPageId(PAGE_ID.MARKET_LOADING);
      let data
      try {
        const res = await queryApolloConfig();
        data = res.data
      } catch (err: any) {
        loading.value = false;
        isShowTimeout.value = true;
        setPageId(PAGE_ID.MARKET_TIMEOUT);
        log.error("request_timeout_err", { err });
        Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_fail_sw", {
          error_msg: err?.message || 'Request timeout',
          error_code: err?.code || 'REQUEST_TIMEOUT',
          apply_source: getOmegaApplySource(),
        });
        return;
      }
      const pageInfo = getApolloConfigMap(data?.fintech_fe_market_page)
      const pageList = pageInfo?.landing_backgrounds
      const isPageInfoList = Array.isArray(pageList) && pageList.length > 0
      if (pageInfo && isPageInfoList) {
        // 如果找到对应配置展示首页
        apolloData.value = pageInfo
        setPageId(PAGE_ID.MARKET_HOME);
      } else {
        // 如果没有找到对应配置展示下线页
        isShowOffline.value = true;
        setPageId(PAGE_ID.MARKET_OFFLINE);
      }
      loading.value = false;
      performance.mark('init-end')
      performance.measure('init-duration', 'init-start', 'init-end')
    }
    const init = () => {
      performance.mark('init-start')
      getApolloConfig();
    }

    init()
    return {
      loading,
      isShowOffline,
      isShowTimeout,
      apolloData,
    };
  },
});
</script>

<style scoped>
.container {
  width: 100%;
}

@media screen and (min-width: 451px) {
  .container {
    width: 750px;
    margin: 0 auto;
  }
}
</style>
 
